import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import VueSocketIO from 'vue-socket.io'

if (process.env.NODE_ENV === 'development') {
  Vue.use(
    new VueSocketIO({
      debug: true,
      connection: 'http://localhost:3000'
    })
  )
} else if (process.env.NODE_ENV === 'production') {
  Vue.use(
    new VueSocketIO({
      debug: false,
      connection: 'https://api.cn2.it',
      options: { path: '/wakify-alsfeld/socket.io' }
    })
  )
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
